$(document).ready(function(){
    let body = $('body');
    let searchButton = $('.eq-header__icon-search .eq-header__icon-link');
    let searchInput = $('.eq-header__icon-search .eq-search-data__form-input input.eq-search-data__input');
    let searchForm = $('.eq-header__icon-search .eq-search-data__form');
    let searchRemove = $('.eq-header__icon-search .eq-search-data__form-input .eq-search-data__remove');

     // Mobile menu start
    $(function () {
        const body = $('body');
        const mobileMenu = $('.mobile-menu');
        const mobileMenuBody = mobileMenu.children('.mobile-menu__body');

        if (mobileMenu.length) {
            const open = function() {
                const bodyWidth = body.width();
                body.css('overflow', 'hidden');
                body.css('paddingRight', (body.width() - bodyWidth) + 'px');

                mobileMenu.addClass('mobile-menu--open');
                body.addClass('is-mobile-menu--open');
            };
            const close = function() {
                body.css('overflow', 'auto');
                body.css('paddingRight', '');

                mobileMenu.removeClass('mobile-menu--open');
                body.removeClass('is-mobile-menu--open');
            };

            $('.mobile-header__menu-button').on('click', function() {
                open();
            });
            $('.mobile-menu__backdrop, .mobile-menu__close').on('click', function() {
                close();
            });
        }

        const panelsStack = [];
        let currentPanel = mobileMenuBody.children('.mobile-menu__panel');

        mobileMenu.on('click', '[data-mobile-menu-trigger]', function(event) {
            const trigger = $(this);
            const item = trigger.closest('[data-mobile-menu-item]');
            let panel = item.data('panel');

            if (!panel) {
                panel = item.children('[data-mobile-menu-panel]').children('.mobile-menu__panel');

                if (panel.length) {
                    mobileMenuBody.append(panel);
                    item.data('panel', panel);
                    panel.width(); // force reflow
                }
            }

            if (panel && panel.length) {
                event.preventDefault();

                panelsStack.push(currentPanel);
                currentPanel.addClass('mobile-menu__panel--hide');

                panel.removeClass('mobile-menu__panel--hidden');
                currentPanel = panel;
            }
        });
        mobileMenu.on('click', '.mobile-menu__panel-back', function() {
            currentPanel.addClass('mobile-menu__panel--hidden');
            currentPanel = panelsStack.pop();
            currentPanel.removeClass('mobile-menu__panel--hide');
        });
    });
    // Mobile menu end

     // Accordion start
    if ($('.js-accordion-list').length > 0) {
        $('.js-accordion-list').each(function () {
            $(this).find('.js-accordion-list-item-body').hide();
        });
        $('.js-accordion-list .js-accordion-list-item-header').click(function (e) {
            let $parentItem = $(this).parent('.js-accordion-list-item');
            let $accordionList = $(this).closest('.js-accordion-list');
            $accordionList.find('.js-accordion-list-item')
                .not($parentItem)
                .removeClass('is--active')
                .find('.js-accordion-list-item-body')
                .slideUp();
            if ($parentItem.hasClass('is--active')) {
                $parentItem.removeClass('is--active').find('.js-accordion-list-item-body').slideUp();
            } else {
                $parentItem.addClass('is--active').find('.js-accordion-list-item-body').slideDown();
            }
            return false;
        });
    }
    // Accordion end

    $(searchButton).on('click', function(e){
        e.preventDefault();
        
        let searchParent = $(this).parent();

        if (searchParent.hasClass('eq-header__icon-search')) {

            if (searchParent.hasClass('eq-search-open')) {
                searchParent.removeClass('eq-search-open');
            } else {
                searchParent.addClass('eq-search-open');
            }
        }
    });

    $(searchInput).on('input.eq-search-data__input', function(){
        if($(this).val().length > 0){
            searchRemove.addClass('has-content');
            searchForm.addClass('search-data-visible');
        } else {
            searchRemove.removeClass('has-content');
            searchForm.removeClass('search-data-visible');
        }
    });

    if(searchInput.length > 0 &&  searchInput.val().length > 0){
        searchRemove.addClass('has-content');
        searchForm.addClass('search-data-visible');
    }

    $(searchRemove).on('click', function(){
        if ($(searchForm).hasClass('search-data-visible') && $(this).hasClass('has-content')) {
            $(searchForm).removeClass('search-data-visible');
            $(this).removeClass('has-content');
        } else {
            
        }
    });

    $(".eq-search-data--desktop predictive-search .reset__button").on('click', function(){
        let searchData = $(".eq-search-data--desktop predictive-search form .search-input").val();
        if (searchData != "") {
            $(".eq-search-data--desktop .predictive-search-result").css("display", "none");
            $(".eq-search-data--desktop predictive-search form .search-input").val("");
            $(this).hide();
        }
    });

    $(".eq-search-data--desktop predictive-search form .search-input").on("keyup", function () {
        if ($(".eq-search-data--desktop predictive-search form .search-input").val().trim() !== "") {
          $(".eq-search-data--desktop predictive-search .reset__button").show();
        } else {
          $(".eq-search-data--desktop predictive-search .reset__button").hide();
        }
    });

    let getSearchDataOnLoad = $('.eq-search-data--desktop predictive-search form .search-input').val();
    if (getSearchDataOnLoad && getSearchDataOnLoad.trim() !== '') {
        $(".eq-search-data--desktop predictive-search .reset__button").show();
    }else {
        $(".eq-search-data--desktop predictive-search .reset__button").hide();
    }


    $(".eq-search-data--mobile predictive-search .reset__button").on('click', function(){
        let searchData = $(".eq-search-data--mobile predictive-search form .search-input").val();
        if (searchData != "") {
            $(".eq-search-data--mobile .predictive-search-result").css("display", "none");
            $(".eq-search-data--mobile predictive-search form .search-input").val("");
            $(this).hide();
        }
    });

    $(".eq-search-data--mobile predictive-search form .search-input").on("keyup", function () {
        if ($(".eq-search-data--mobile predictive-search form .search-input").val().trim() !== "") {
          $(".eq-search-data--mobile predictive-search .reset__button").show();
        } else {
          $(".eq-search-data--mobile predictive-search .reset__button").hide();
        }
    });

    let getSearchDataOnLoadMob = $('.eq-search-data--desktop predictive-search form .search-input').val();

    if (getSearchDataOnLoadMob && getSearchDataOnLoadMob.trim() !== '') {
        $(".eq-search-data--mobile predictive-search .reset__button").show();
    }else {
        $(".eq-search-data--mobile predictive-search .reset__button").hide();
    }
    

    $(document).on('click', function(e) {
        let container = $(".eq-header__icon-link, .eq-search-data__wrap");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".eq-header__icon-search").removeClass("eq-search-open");
        }
    });

    $(document).on('click', function(e) {
        let container = $(".blog-search-complete, .eq-blog-list__search input, .eq-blog-list__search svg");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".blog-search-complete").hide();
            $(".eq-blog-list__search input").val("");
            $(".eq-blog-list__search .search-block .remove").removeClass("active");
        }
    });

    let hamburgerButton = $('.eq-header__btn-hamburger');
    let closeButton = $('.eq-header__btn-menuclose');
    let menu = $('.eq-header__menu');
    let menuWrapper = $('.eq-header__wrapper');

    function updateMenuHeight() {
        let headerHeight = $('.eq-header').outerHeight();
        let announcementBarHeight = 0;
        // let announcementBarHeight = $('.eq-announcement-bar').outerHeight();
        // let totalHeight = headerHeight + announcementBarHeight;

        if ($('.eq-announcement-bar').length > 0 && $('.eq-announcement-bar').is(':visible')) {
            announcementBarHeight = $('.eq-announcement-bar').outerHeight();
        }

        let totalHeight = headerHeight + announcementBarHeight;        
        
        menu.css({
            'height': 'calc(100dvh - ' + totalHeight + 'px)',
            'top': totalHeight + 'px'
        });
    }

    if ($(window).width() <= 991) {

        function openMenu() {
            menuWrapper.addClass('is-menu-open');
            body.addClass('hide-overflow')
            body.addClass('is-menu-open');
            updateMenuHeight();
        }
        
        function closeMenu() {
            menuWrapper.removeClass('is-menu-open');
            body.removeClass('hide-overflow')
            body.removeClass('is-menu-open');

            menu.css({
                'height': '100dvh',
                'top': '-100%'
            });
        }

        hamburgerButton.on('click', openMenu);
        closeButton.on('click', closeMenu);

        $('.eq-header__nav-link').on('click', function(e) {
            let parentItem = $(this).closest('.eq-header__nav-item');
            let submenu = parentItem.find('.eq-header__nav-dropdown');
    
            $('.eq-header__nav-item').not(parentItem).each(function() {
                let otherSubmenu = $(this).find('.eq-header__nav-dropdown');
                if (otherSubmenu.is(':visible')) {
                    otherSubmenu.slideUp(300);
                    $(this).removeClass('is-submenu-open');
                }
            });
    
            if (submenu.length) {
                e.preventDefault();
    
                if (parentItem.hasClass('is-submenu-open')) {
                    submenu.slideUp(300);
                    parentItem.removeClass('is-submenu-open');
                } else {
                    submenu.slideDown(300);
                    parentItem.addClass('is-submenu-open');
                }
            }
        });

        $(window).on('resize', function() {
            updateMenuHeight();
        });

    }


    // Function to initialize slick slider
    function initializeSlick(element) {
        let wrap = $(element).find('.product-tab-detail__wrap');
        
        if ($(element).hasClass('tab-slider-view')) {
            if (!wrap.hasClass('slick-initialized')) {
                wrap.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        }
    }

    function resizeSlick(element) {
        let wrap = $(element).find('.product-tab-detail__wrap');
        if (wrap.hasClass('slick-initialized')) {
            wrap.slick('setPosition');            
        }
    }


    $('.product-tab-detail__heading').on('click', function(e) {
        let parentItem = $(this).closest('.product-tab-detail');
        let wrap = parentItem.find('.product-tab-detail__wrap');
        
        $('.product-tab-detail').not(parentItem).each(function() {
            let otherWrap = $(this).find('.product-tab-detail__wrap');
            if (otherWrap.is(':visible')) {
                // otherWrap.slideUp(300);
                otherWrap.addClass('hidden-slider').slideUp(300, function() {
                    // Optionally, reset visibility here if needed
                });
                $(this).removeClass('is-dropdown-open');
            }
        });

        if (wrap.length) {
            e.preventDefault();

            if (parentItem.hasClass('is-dropdown-open')) {
                wrap.slideUp(300, function() {
                    if ($(window).width() <= 767) {
                        wrap.addClass('hidden-slider');
                    }
                });
                parentItem.removeClass('is-dropdown-open');
            } else {
                wrap.slideDown(300, function() {
                    if ($('.eq-product-tab__tab-detail').hasClass('tab-slider-view')) {
                        if ($(window).width() <= 767) {
                            wrap.removeClass('hidden-slider'); 
                        }
                        initializeSlick(parentItem);
                        resizeSlick(parentItem);
                        
                    }                
                });
                parentItem.addClass('is-dropdown-open');
            }
        }
    });

    function initialize() {
        let windowWidth = $(window).width();

        $('.eq-product-tab__tab-detail').each(function() {
            let tabDetail = $(this);
            let wrap = tabDetail.find('.product-tab-detail__wrap');

            if (tabDetail.hasClass('tab-grid-view')) {

                if (wrap.hasClass('slick-initialized')) {
                    wrap.slick('unslick');
                }
            } else if (tabDetail.hasClass('tab-slider-view')) {
                if (windowWidth <= 767) {
                    wrap.addClass('hidden-slider');
                }
                initializeSlick(tabDetail);
            }
        });

        if (windowWidth > 767) {
            $('.eq-product-tab__tab-item:first-child').addClass('active');
            $('.eq-product-tab__tab-detail .product-tab-detail').first().addClass('active');
        } else {
            $('.product-tab-detail__wrap').slideUp(0);
            $('.product-tab-detail').removeClass('is-dropdown-open');
        }
    }

    initialize();

    $('.js-product-tab-button').on('click', function(e) {
        e.preventDefault();
        let tabButton = $(this);
        let targetTab = tabButton.attr('data-city');
        tabButton.parent().addClass('active');
        tabButton.parent().siblings().removeClass('active');

        $('.eq-product-tab__tab-detail .product-tab-detail').each(function() {
            if ($(this).attr('id') === targetTab) {
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
                if ($('.eq-product-tab__tab-detail').hasClass('tab-slider-view')) {
                    resizeSlick($(this));
                }
            } else {
                $(this).removeClass('active');
            }
        });
    });

    let ProductReviewSlider = $('.js-product-review-slider');

    let slidesToShowDesktop = ProductReviewSlider.attr('data-slide-desktop') && ProductReviewSlider.attr('data-slide-desktop') !== "" && ProductReviewSlider.attr('data-slide-desktop') !== undefined && ProductReviewSlider.attr('data-slide-desktop') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-desktop')) : 3;

    let slidesToShowTablet = ProductReviewSlider.attr('data-slide-tablet') && ProductReviewSlider.attr('data-slide-tablet') !== "" && ProductReviewSlider.attr('data-slide-tablet') !== undefined && ProductReviewSlider.attr('data-slide-tablet') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-tablet')) : 2;

    let slidesToShowMobile = ProductReviewSlider.attr('data-slide-mobile') && ProductReviewSlider.attr('data-slide-mobile') !== "" && ProductReviewSlider.attr('data-slide-mobile') !== undefined && ProductReviewSlider.attr('data-slide-mobile') !== null ?
    parseInt(ProductReviewSlider.attr('data-slide-mobile')) : 1;

    if(ProductReviewSlider.length > 0 && ProductReviewSlider.find('.eq-product-review__slide').length > 0 ){
        ProductReviewSlider.slick({
            slidesToShow: slidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            // prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            // nextArrow: '<button type="button" class="next-arrow slick-next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.02734 1.00879L2.02734 6.50879L7.02734 12.0088" stroke="#A12655" stroke-width="3"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.11035 1.00879L6.11035 6.50879L1.11035 12.0088" stroke="#A12655" stroke-width="3"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: slidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: slidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let reviewSliderTitle = $('.eq-product-review__slide .eq-product-review__detail .eq-product-review__block-title');

    if(reviewSliderTitle.length > 0){
        reviewSliderTitle.matchHeight({ 
            byRow: true,
        });
    }

    let reviewSliderInformation = $('.eq-product-review__slide .eq-product-review__detail .eq-product-review__rte');

    if(reviewSliderInformation.length > 0){
        reviewSliderInformation.matchHeight({ 
            byRow: true,
        });
    }


    let sellProduct = $('.js-our-sellers');

    if(sellProduct.length > 0 && sellProduct.find('.eq-our-sellers__slide').length > 0 ){
        sellProduct.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            loop: false,
            infinite: false,
            autoplay: false,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.15,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }


    let articleListSlider = $('.js-article-list-slider');

    let articleSlidesToShowDesktop = articleListSlider.attr('data-slide-desktop') && articleListSlider.attr('data-slide-desktop') !== "" && articleListSlider.attr('data-slide-desktop') !== undefined && articleListSlider.attr('data-slide-desktop') !== null ?
    parseInt(articleListSlider.attr('data-slide-desktop')) : 3;

    let articleSlidesToShowTablet = articleListSlider.attr('data-slide-tablet') && articleListSlider.attr('data-slide-tablet') !== "" && articleListSlider.attr('data-slide-tablet') !== undefined && articleListSlider.attr('data-slide-tablet') !== null ?
    parseInt(articleListSlider.attr('data-slide-tablet')) : 2;

    let articleSlidesToShowMobile = articleListSlider.attr('data-slide-mobile') && articleListSlider.attr('data-slide-mobile') !== "" && articleListSlider.attr('data-slide-mobile') !== undefined && articleListSlider.attr('data-slide-mobile') !== null ?
    parseInt(articleListSlider.attr('data-slide-mobile')) : 1;

    if(articleListSlider.length > 0 && articleListSlider.find('.eq-article-list__slide').length > 0 ){
        articleListSlider.slick({
            slidesToShow: articleSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: articleSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: articleSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let articleSliderInformation = $('.eq-article-list .eq-article-list__block-title');

    if(articleSliderInformation.length > 0){
        articleSliderInformation.matchHeight({ 
            byRow: true,
        });
    }

    let testimonialSliderL1 = $('.js-testimonials-slider-l1');

    if(testimonialSliderL1.length > 0 && testimonialSliderL1.find('.eq-testimonials-l1__slide').length > 0 ){
        testimonialSliderL1.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg></button>',
        });
    }   

    // quantity plus/minus
    $(document).on("click", ".js-btn-quantity", function (e) {
        e.preventDefault();
        let parent = $(this).closest('.quantity-main');
        let value = parseInt(parent.find('.quantity-input').val()) || 0;
        if ($(this).hasClass('quantity-plus')) {
            value++;
        } else if ($(this).hasClass('quantity-minus')) {
            if (value > 1) {
                value--;
            }
        }
        parent.find('.quantity-input').val(value);
    });
    // end quantity plus/minus

    let PdpSliderProductFor = $('.js-pdp-slider-for');
    let PdpSliderProductNav = $('.js-pdp-slider-nav');

    if(PdpSliderProductFor.length > 0 && PdpSliderProductFor.find('.slider-for__item').length > 0 ){
        PdpSliderProductFor.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.js-pdp-slider-nav'
        });
        PdpSliderProductNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.js-pdp-slider-for',
            dots: false,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><img src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/Group_15_1.svg?v=1719220100" alt="icon" /></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><img src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/Group_1000001401_1.svg?v=1719220072" alt="icon" /></button>',
        });
    }

    $('.eq-pdp-tab__list li a').on('click', function (e) {
        e.preventDefault();
    
        let targetId = $(this).attr('data-id');        
        $('.eq-pdp-tab__list li').removeClass('tab-active');
        $(this).parent().addClass('tab-active');
    
        if (targetId) {
            $("#" + targetId).fadeIn('slow').siblings(".eq-pdp-tab__content-list").hide();
        } else {
            let href = $(this).attr('href'); 
            if (href && href !== '#') {
                let $target = $(href);
                if ($target.length) {
                    $('html, body').animate({
                        scrollTop: $target.offset().top
                    }, 800);
                }
            }
        }
    });
    
    /*
        $('.eq-faq .accordion > li:first-child').addClass('active');
        $('.eq-faq .accordion > li.active .ans').slideDown();

        $('.eq-faq .accordion h6').on("click", function() {
            let dropDown = $(this).closest('li').find('.ans');

            $(this).closest('.accordion').find('.ans').not(dropDown).slideUp();

            if ($(this).parent("li").hasClass('active')) {
                $(this).parent("li").removeClass('active');
            } else {
                $(this).closest('.accordion').find('li.active').removeClass('active');
                $(this).parent("li").addClass('active');
            }

            dropDown.stop(false, true).slideToggle();

        });
    */


    // if($('.eq-joy-customers__slider-item .product-card .product-card__title').length > 0){
    //     $('.eq-joy-customers__slider-item .product-card .product-card__title').matchHeight({
    //         byRow: 0,
    //     });
    // }


    if($('.product-card .product-card__badeges .product-card__badege-media').length > 0){
        $('.product-card .product-card__badeges .product-card__badege-media').matchHeight({
            byRow: true,
        });
    }

    let middleBadeges = $('.product-card .product-card__badeges-middle');
    if(middleBadeges.length > 0){
        middleBadeges.matchHeight({ 
            byRow: true,
        });
    }

    if($('.product-card .product-card__title').length > 0){
        $('.product-card .product-card__title').matchHeight({
            byRow: true,
        });
    }

    if($('.eq-cbd-best-sellers__box-content .desc').length > 0){
        $('.eq-cbd-best-sellers__box-content .desc').matchHeight({
            byRow: true,
        });
    }
    
    let collectionDetailBlock = $('.eq-collection-header__information');
    let collectionDetail = $('.eq-collection-header__information p');
    let collectionDetailShowHideBtn = $('#eq-collection-header__toggle-detail');
    
    function truncateText(contentElement) {
        let content = contentElement.text();
        let wordCount = content.split(' ').length;
        
        if (wordCount > 50) {
            var truncatedText = content.split(' ').slice(0, 40).join(' ') + '...';
            contentElement.data('full-text', content);
            contentElement.text(truncatedText);
            return true;
        } else {
            contentElement.data('full-text', content);
            return false;
        }
    }

    if(collectionDetailBlock.length > 0 && collectionDetailBlock.hasClass('is-truncate-detail') && collectionDetailShowHideBtn.length > 0){
        if (truncateText(collectionDetail)) {
            collectionDetailShowHideBtn.show();
        }
    
        $(collectionDetailShowHideBtn).on('click', function(e) { 
            e.preventDefault();
            var fullText = collectionDetail.data('full-text');
    
            if (collectionDetail.text().indexOf('...') !== -1) {
                collectionDetail.text(fullText);
                collectionDetailShowHideBtn.text('Read Less');
            } else {
                var truncatedText = fullText.split(' ').slice(0, 40).join(' ') + '...';
                collectionDetail.text(truncatedText);
                collectionDetailShowHideBtn.text('Read More');
            }
        });
    }


    let testimonialSliderL2 = $('.js-testimonials-slider-l2');

    if(testimonialSliderL2.length > 0 && testimonialSliderL2.find('.eq-testimonials-l2__slide').length > 0 ){
        testimonialSliderL2.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            autoplay: false,
            infinite: false,
            variableWidth: true,
            loop: false,
            prevArrow: '.prev-arrow',
            nextArrow: '.next-arrow',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Handle the disabling of custom arrows based on Slick's `slick-disabled` class
        testimonialSliderL2.on('afterChange', function(event, slick, currentSlide) {
            updateArrowState(slick);
        });

        // Update arrow state (enabled/disabled) on initialization and after each change
        function updateArrowState(slick) {
            if(slick.slickCurrentSlide() === 0) {
                $('.prev-arrow').addClass('slick-disabled');
            } else {
                $('.prev-arrow').removeClass('slick-disabled');
            }
    
            if(slick.slickCurrentSlide() === slick.slideCount - 1) {
                $('.next-arrow').addClass('slick-disabled');
            } else {
                $('.next-arrow').removeClass('slick-disabled');
            }
        }

        // Initial arrow state check
        updateArrowState(testimonialSliderL2.slick('getSlick'));
    }

    /*
    let testimonialSliderL3 = $('.js-testimonials-slider-l3');

    if(testimonialSliderL3.length > 0 && testimonialSliderL3.find('.eq-testimonials-l3__slide').length > 0 ){
        testimonialSliderL3.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
    */

    if($('.js-compare-products-products-slider').length > 0 ){
        $('.js-compare-products-products-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            loop: false,
            infinite: false,
            autoplay: false,
            prevArrow: $('.js-compare-products-products-slider-prev'),
            nextArrow: $('.js-compare-products-products-slider-next'),
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    if($('.eq-testimonials-l3__information h6').length > 0){
        $('.eq-testimonials-l3__information h6').matchHeight({
            byRow: 1,
        });
    }
    if($('.eq-testimonials-l3__information p').length > 0){
        $('.eq-testimonials-l3__information p').matchHeight({
            byRow: 1,
        });
    }
    if($('.eq-process-step__block .eq-process-step__block-title').length > 0){
        $('.eq-process-step__block .eq-process-step__block-title').matchHeight({
            byRow: 1,
        });
    }

    if ($('.eq-accordion__box').length > 0) {
        $('.eq-accordion__box').each(function() {
            if($(this).hasClass('eq-accordion__no-accordion')){
               
            } else if ($(this).find('.eq-accordion__row').hasClass('is-accordion-open') && $(this).find('.eq-accordion__col').length > 0) {
                
                $(this).find('.eq-accordion__col').each(function() {
                    if( $(this).find('.eq-accordion__block').length > 0 && $(this).find('.eq-accordion__answer').length > 0){
                        if (!$(this).find('.eq-accordion__block').hasClass('is-active-accordion')) {
                            $(this).find('.eq-accordion__block').addClass('is-active-accordion');
                        }
                        if (!$(this).find('.eq-accordion__answer').hasClass('is-open-detail')) {
                            $(this).find('.eq-accordion__answer').addClass('is-open-detail').slideDown(350);
                        }
                    }
                });
            }
        });
    }

    if ($('.eq-accordion__question').length > 0) {
        $('.eq-accordion__box').each(function() {
            let currentBox = $(this);

            if (!currentBox.is('.eq-accordion__no-accordion')) {
                currentBox.find('.eq-accordion__question').on('click', function() {
                    let accordionBlock = $(this).closest('.eq-accordion__block');
                    let accordionAnswer = accordionBlock.find('.eq-accordion__answer');
    
                    /*
                    currentBox.find('.eq-accordion__block').not(accordionBlock).removeClass('is-active-accordion');
                    currentBox.find('.eq-accordion__answer').not(accordionAnswer).removeClass('is-open-detail');
                    */
    
                    if (!accordionBlock.hasClass('is-active-accordion')) {
                        accordionBlock.addClass('is-active-accordion');
                        accordionAnswer.addClass('is-open-detail').slideDown(350);
                    } else {
                        accordionBlock.removeClass('is-active-accordion');
                        accordionAnswer.removeClass('is-open-detail').slideUp(350);
                    }
                });
            }
        });
    }

    if ($('.js-faq-card-header').length > 0) {
        $('.js-faq-card-header').on('click', function () {
            var thisElement = $(this);
            var currentBody = thisElement.next('.eq-faq-v1__card-body');

            // Close all other FAQ cards
            $('.js-faq-card-header').not(thisElement).removeClass('active');
            $('.eq-faq-v1__card-body').not(currentBody).stop(true, true).slideUp();

            // Toggle the current FAQ
            thisElement.toggleClass('active');
            currentBody.stop(true, true).slideToggle();
        });
    }

    let collectionProductSlider = $('.js-collection-product-slider');

    let collectionSlidesToShowDesktop = collectionProductSlider.attr('data-slide-desktop') && collectionProductSlider.attr('data-slide-desktop') !== "" && collectionProductSlider.attr('data-slide-desktop') !== undefined && collectionProductSlider.attr('data-slide-desktop') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-desktop')) : 3;

    let collectionSlidesToShowTablet = collectionProductSlider.attr('data-slide-tablet') && collectionProductSlider.attr('data-slide-tablet') !== "" && collectionProductSlider.attr('data-slide-tablet') !== undefined && collectionProductSlider.attr('data-slide-tablet') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-tablet')) : 2;

    let collectionSlidesToShowMobile = collectionProductSlider.attr('data-slide-mobile') && collectionProductSlider.attr('data-slide-mobile') !== "" && collectionProductSlider.attr('data-slide-mobile') !== undefined && collectionProductSlider.attr('data-slide-mobile') !== null ?
    parseInt(collectionProductSlider.attr('data-slide-mobile')) : 1;

    if(collectionProductSlider.length > 0 && collectionProductSlider.find('.eq-collection-product__block').length > 0 ){
        collectionProductSlider.slick({
            slidesToShow: collectionSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: collectionSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: collectionSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    let collectionProductSliderl1 = $('.js-collection-product-l1-slider');

    let collectionSlidesToShowDesktop1 = collectionProductSliderl1.attr('data-slide-desktop') && collectionProductSliderl1.attr('data-slide-desktop') !== "" && collectionProductSliderl1.attr('data-slide-desktop') !== undefined && collectionProductSliderl1.attr('data-slide-desktop') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-desktop')) : 3;

    let collectionSlidesToShowTablet1 = collectionProductSliderl1.attr('data-slide-tablet') && collectionProductSliderl1.attr('data-slide-tablet') !== "" && collectionProductSliderl1.attr('data-slide-tablet') !== undefined && collectionProductSliderl1.attr('data-slide-tablet') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-tablet')) : 2;

    let collectionSlidesToShowMobile1 = collectionProductSliderl1.attr('data-slide-mobile') && collectionProductSliderl1.attr('data-slide-mobile') !== "" && collectionProductSliderl1.attr('data-slide-mobile') !== undefined && collectionProductSliderl1.attr('data-slide-mobile') !== null ?
    parseInt(collectionProductSliderl1.attr('data-slide-mobile')) : 1;

    if(collectionProductSliderl1.length > 0 && collectionProductSliderl1.find('.eq-collection-product-l1__block').length > 0 ){
        collectionProductSliderl1.slick({
            slidesToShow: collectionSlidesToShowDesktop1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: collectionSlidesToShowTablet1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: collectionSlidesToShowMobile1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }


    let featuredCollectionProductSlider = $('.js-featured-collection-product-slider');

    let featuredCollectionSlidesToShowDesktop = featuredCollectionProductSlider.attr('data-slide-desktop') && featuredCollectionProductSlider.attr('data-slide-desktop') !== "" && featuredCollectionProductSlider.attr('data-slide-desktop') !== undefined && featuredCollectionProductSlider.attr('data-slide-desktop') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-desktop')) : 3;

    let featuredCollectionSlidesToShowTablet = featuredCollectionProductSlider.attr('data-slide-tablet') && featuredCollectionProductSlider.attr('data-slide-tablet') !== "" && featuredCollectionProductSlider.attr('data-slide-tablet') !== undefined && featuredCollectionProductSlider.attr('data-slide-tablet') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-tablet')) : 2;

    let featuredCollectionSlidesToShowMobile = featuredCollectionProductSlider.attr('data-slide-mobile') && featuredCollectionProductSlider.attr('data-slide-mobile') !== "" && featuredCollectionProductSlider.attr('data-slide-mobile') !== undefined && featuredCollectionProductSlider.attr('data-slide-mobile') !== null ?
    parseInt(featuredCollectionProductSlider.attr('data-slide-mobile')) : 1;

    
    if(featuredCollectionProductSlider.length > 0 && featuredCollectionProductSlider.find('.eq-featured-product__block').length > 0 ){
        featuredCollectionProductSlider.slick({
            slidesToShow: featuredCollectionSlidesToShowDesktop,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-arrow"><polygon points="95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46"></polygon></g></svg></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-arrow"><polygon points="57.09 16.78 51.82 22.8 78.32 46 4.96 46 4.96 54 78.32 54 51.82 77.2 57.09 83.22 95.04 50 57.09 16.78"></polygon></g></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: featuredCollectionSlidesToShowTablet,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: featuredCollectionSlidesToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    $('.history-btn, .history-close').on('click', function(e){
        e.preventDefault();
        if($('.history-modal').length > 0){
            $('.history-modal').toggleClass('is-active');
        }
    });
    
    $(document).on('click', '.eq-announcement-bar__close-button ', function(e) {
        e.preventDefault();
        $('.eq-announcement-bar').remove();

        if ($(window).width() <= 991) {
            updateMenuHeight();
        } else {
            handleStickyElements();
        }
    });

    $('.eq-videos-expertise-l1__item[data-fancybox]').fancybox({});

    let testimonialSliderL4 = $('.js-testimonials-slider-l4');
    
    let prevArrowCustom = `<svg role="presentation" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3174 14.9401L6.42738 10.0501C5.84988 9.47256 5.84988 8.52756 6.42738 7.95006L11.3174 3.06006" stroke="#393939" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    let nextArrowCustom = `<svg role="presentation" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68262 14.9401L11.5726 10.0501C12.1501 9.47256 12.1501 8.52756 11.5726 7.95006L6.68262 3.06006" stroke="#393939" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    if(testimonialSliderL4.length > 0 && testimonialSliderL4.find('.eq-testimonials-l4__slide').length > 0){
        testimonialSliderL4.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" class="prev-arrow" aria-label="previous">${prevArrowCustom}</button>`,
            nextArrow: `<button type="button" class="next-arrow" aria-label="next">${nextArrowCustom}</button>`,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    let testimonialSliderL5 = $('.js-testimonials-slider-l5');
    
    let prevArrowCustomL5 = `<img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow">`;
    let nextArrowCustomL5 = `<img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow">`;

    if(testimonialSliderL5.length > 0 && testimonialSliderL5.find('.eq-testimonials-l5__item').length > 0){
        testimonialSliderL5.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            infinite: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" class="prev-arrow" aria-label="previous">${prevArrowCustomL5}</button>`,
            nextArrow: `<button type="button" class="next-arrow" aria-label="next">${nextArrowCustomL5}</button>`,
        });
    }

    let sliderUsp = $(".js-pdp-l2-usp-slider");

    if(sliderUsp.length > 0 && sliderUsp.find('.eq-pdp-l2__usp-slider-col').length > 0){
        let sliderUspOption = {
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: "linear",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            mobileFirst: !0,
            responsive: [{ breakpoint: 992, settings: "unslick" }],
        };
        let winSliderUsp = $(window);
        winSliderUsp.on("load resize", function () {
            winSliderUsp.width() < 992 ? sliderUsp.not(".slick-initialized").slick(sliderUspOption) : sliderUsp.hasClass("slick-initialized") && sliderUsp.slick("unslick");
        });
    }


    if ($('.eq-accordion-l3__question').length > 0) {
        $('.eq-accordion-l3__box').each(function() {
            let currentBox = $(this);

            currentBox.find(".eq-accordion-l3__col").first().find(".eq-accordion-l3__block").addClass('is-active-accordion');
            currentBox.find(".eq-accordion-l3__col").first().find(".eq-accordion-l3__block .eq-accordion-l3__answer").addClass('is-open-detail').slideDown(350);

            currentBox.find('.eq-accordion-l3__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-accordion-l3__block');
                let accordionAnswer = accordionBlock.find('.eq-accordion-l3__answer');

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    let cbdBestSellerSlider = $('.js-cbd-best-sellers-slider');

    let cbdBestSellerSlidesToShowDesk = cbdBestSellerSlider.attr('data-desktop') && cbdBestSellerSlider.attr('data-desktop') !== "" && cbdBestSellerSlider.attr('data-desktop') !== undefined && cbdBestSellerSlider.attr('data-desktop') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-desktop')) : 4;

    let cbdBestSellerSlidesToShowTab = cbdBestSellerSlider.attr('data-tablet') && cbdBestSellerSlider.attr('data-tablet') !== "" && cbdBestSellerSlider.attr('data-tablet') !== undefined && cbdBestSellerSlider.attr('data-tablet') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-tablet')) : 3;

    let cbdBestSellerSlidesToShowMob = cbdBestSellerSlider.attr('data-mobile') && cbdBestSellerSlider.attr('data-mobile') !== "" && cbdBestSellerSlider.attr('data-mobile') !== undefined && cbdBestSellerSlider.attr('data-mobile') !== null ?
    parseInt(cbdBestSellerSlider.attr('data-mobile')) : 1;
    
    if(cbdBestSellerSlider.length > 0 && cbdBestSellerSlider.find('.eq-cbd-best-sellers__box').length > 0){
        cbdBestSellerSlider.slick({
            slidesToShow: cbdBestSellerSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,        
            loop: false,
            infinite: false,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: cbdBestSellerSlidesToShowTab,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: cbdBestSellerSlidesToShowMob,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let popularCategoriesSlider = $('.js-popular-categories-slider');

    let popularCategoriesSlidesToShowDesk = popularCategoriesSlider.attr('data-desktop') && popularCategoriesSlider.attr('data-desktop') !== "" && popularCategoriesSlider.attr('data-desktop') !== undefined && popularCategoriesSlider.attr('data-desktop') !== null ?
    parseInt(popularCategoriesSlider.attr('data-desktop')) : 2;

    let popularCategoriesSlidesToShowTab = popularCategoriesSlider.attr('data-tablet') && popularCategoriesSlider.attr('data-tablet') !== "" && popularCategoriesSlider.attr('data-tablet') !== undefined && popularCategoriesSlider.attr('data-tablet') !== null ?
    parseInt(popularCategoriesSlider.attr('data-tablet')) : 2;

    let popularCategoriesSlidesToShowMob = popularCategoriesSlider.attr('data-mobile') && popularCategoriesSlider.attr('data-mobile') !== "" && popularCategoriesSlider.attr('data-mobile') !== undefined && popularCategoriesSlider.attr('data-mobile') !== null ?
    parseInt(popularCategoriesSlider.attr('data-mobile')) : 1;
    
    if(popularCategoriesSlider.length > 0 && popularCategoriesSlider.find('.eq-popular-categories__item').length > 0){
        popularCategoriesSlider.slick({
            slidesToShow: popularCategoriesSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" class="prev-arrow" aria-label="previous"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow"></button>`,
            nextArrow: `<button type="button" class="next-arrow" aria-label="next"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow"></button>`,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: popularCategoriesSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: popularCategoriesSlidesToShowMob,
                    }
                }
            ]
        });
    }

    $(window).scroll(function() {
        let imgOnScroll = $(this).scrollTop();
        $('.js-scroll-function').css('background-position', parseInt(-imgOnScroll / 1) + 'px');
    });

    $('.js-cbd-info-btn').on('click', function() {
        $('.js-cbd-information-model').addClass('show');
        $('body').addClass('hidden-scroll');
    });
    
    $('.js-cbd-information-model .close').on('click', function() {
        $('.js-cbd-information-model').removeClass('show');
        $('body').removeClass('hidden-scroll');
    });

    $(document).on('click', function(e) {
        let container = $(".js-cbd-information-model .cbd-information-model__content, .js-cbd-info-btn");

        if (!$(container).is(e.target) && $(container).has(e.target).length === 0) 
        {
            $(".js-cbd-information-model").removeClass("show");
            $('body').removeClass('hidden-scroll');
        }
    });

    let exploreArticleSlider = $('.js-explore-article-slider');

    let exploreArticleSlidesToShowDesk = exploreArticleSlider.attr('data-desktop') && exploreArticleSlider.attr('data-desktop') !== "" && exploreArticleSlider.attr('data-desktop') !== undefined && exploreArticleSlider.attr('data-desktop') !== null ?
    parseInt(exploreArticleSlider.attr('data-desktop')) : 3;

    let exploreArticleSlidesToShowTab = exploreArticleSlider.attr('data-tablet') && exploreArticleSlider.attr('data-tablet') !== "" && exploreArticleSlider.attr('data-tablet') !== undefined && exploreArticleSlider.attr('data-tablet') !== null ?
    parseInt(exploreArticleSlider.attr('data-tablet')) : 2;

    let exploreArticleSlidesToShowMob = exploreArticleSlider.attr('data-mobile') && exploreArticleSlider.attr('data-mobile') !== "" && exploreArticleSlider.attr('data-mobile') !== undefined && exploreArticleSlider.attr('data-mobile') !== null ?
    parseInt(exploreArticleSlider.attr('data-mobile')) : 1;
    
    if(exploreArticleSlider.length > 0 && exploreArticleSlider.find('.eq-explore-article__item').length > 0){
        exploreArticleSlider.slick({
            slidesToShow: exploreArticleSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: `<button type="button" class="prev-arrow" aria-label="previous"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-l.png?v=173563952378923971611731911966" alt="prev arrow"></button>`,
            nextArrow: `<button type="button" class="next-arrow" aria-label="next"><img src="https://joyorganics.com/cdn/shop/t/160/assets/arrow-r.png?v=64802038806612222901731911967" alt="next arrow"></button>`,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: exploreArticleSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: exploreArticleSlidesToShowMob,
                    }
                }
            ]
        });
    }

    let videoExpertiseLayout1 = $('.js-videos-expertise-l1');

    let videoExpertiseSlidesToShowDesk = videoExpertiseLayout1.attr('data-desktop') && videoExpertiseLayout1.attr('data-desktop') !== "" && videoExpertiseLayout1.attr('data-desktop') !== undefined && videoExpertiseLayout1.attr('data-desktop') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-desktop')) : 5;
    
    let videoExpertiseSlidesToShowTab = videoExpertiseLayout1.attr('data-tablet') && videoExpertiseLayout1.attr('data-tablet') !== "" && videoExpertiseLayout1.attr('data-tablet') !== undefined && videoExpertiseLayout1.attr('data-tablet') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-tablet')) : 3;

    let videoExpertiseSlidesToShowMob = videoExpertiseLayout1.attr('data-mobile') && videoExpertiseLayout1.attr('data-mobile') !== "" && videoExpertiseLayout1.attr('data-mobile') !== undefined && videoExpertiseLayout1.attr('data-mobile') !== null ?
    parseInt(videoExpertiseLayout1.attr('data-mobile')) : 1;

    if(videoExpertiseLayout1.length > 0 && videoExpertiseLayout1.find('.eq-videos-expertise-l1__item').length > 0 ){
        videoExpertiseLayout1.slick({
            slidesToShow: videoExpertiseSlidesToShowDesk,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        centerMode: true,
                        slidesToShow: videoExpertiseSlidesToShowDesk - 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        slidesToShow: videoExpertiseSlidesToShowTab,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: videoExpertiseSlidesToShowMob,
                    }
                }
            ]
        });
    }

    let sliderUspHeader = $(".js-softgel-header-usp");

    if(sliderUspHeader.length > 0 && sliderUspHeader.find('.eq-softgel-header__usp-slider-col').length > 0){
        let sliderUspHeaderOption = {
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: "linear",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            mobileFirst: !0,
            responsive: [{ breakpoint: 992, settings: "unslick" }],
        };
        let winSliderUspHeader = $(window);
        winSliderUspHeader.on("load resize", function () {
            winSliderUspHeader.width() < 992 ? sliderUspHeader.not(".slick-initialized").slick(sliderUspHeaderOption) : sliderUspHeader.hasClass("slick-initialized") && sliderUspHeader.slick("unslick");
        });
    }

    if($('.eq-lab__heading').length > 0){
        $('.eq-lab__heading').matchHeight({
            byRow: true,
        });
    }
    if($('.eq-lab__desc .eq-button').length > 0){
        $('.eq-lab__desc .eq-button').matchHeight({
            byRow: true,
        });
    }

    if ($('.eq-advertorial-accordion__question').length > 0) {
        $('.eq-advertorial-accordion__box').each(function() {
            let currentBox = $(this);

            currentBox.find('.eq-advertorial-accordion__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-advertorial-accordion__block');
                let accordionAnswer = accordionBlock.find('.eq-advertorial-accordion__answer');

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    let heroSlider = $('.js-banner-slider');

    if(heroSlider.length > 0){
        heroSlider.each(function() {
            $(this).slick({
                dots: true,
                infinite: true,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: false,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        autoplaySpeed: 5000,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        autoplaySpeed: 5000,
                    }
                }]
            });
        });  
    }

    $('.eq-virtual-partnership iframe, .eq-page-list__desc iframe').each(function() {
        let iframeSrcGet = $(this).attr('src');
        if (iframeSrcGet && (iframeSrcGet.includes('youtube.com') || iframeSrcGet.includes('vimeo.com'))) {
            $(this).wrap('<div class="lazyframe lazyframe--embedded-video lazyframe--loaded"></div>');
        }
    });

    function switchTab(tabId) {
        $('.eq-videos-expertise-l2__tab li').removeClass('is-tab-active');
        $('.eq-videos-expertise-l2__list').removeClass('is-tab-active').hide();
        
        const selectedTab = $(`.eq-videos-expertise-l2__tab li[data-id="${tabId}"]`);
        const selectedContent = $(`#${tabId}`);
        
        selectedTab.addClass('is-tab-active');
        selectedContent.addClass('is-tab-active').show();
    }
    
    if(($('.eq-videos-expertise-l2__tab li').length > 0 && $('.eq-videos-expertise-l2__list').length > 0) && ($('.eq-videos-expertise-l2__tab li').length > 0 == $('.eq-videos-expertise-l2__list').length > 0)) {
        switchTab($('.eq-videos-expertise-l2__tab li').first().data('id'));
    }

    $('.eq-videos-expertise-l2__tab li').on('click', function() {
        const tabId = $(this).data('id');
        switchTab(tabId);
    });


    let salesProductSlider = $('.js-sales-product');
    if(salesProductSlider.length > 0 && salesProductSlider.find('.eq-sales-product__item').length > 0 ){
        salesProductSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow slick-prev"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow.png?v=16790249251990827964" alt="Slider Arrow"></button>',
            nextArrow: '<button type="button" class="next-arrow slick-next"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow.png?v=16790249251990827964" alt="Slider Arrow"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let testimonialSliderSales = $('.js-testimonials-sales-slider');

    if(testimonialSliderSales.length > 0 && testimonialSliderSales.find('.eq-testimonials-sales__slide').length > 0 ){
        testimonialSliderSales.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow2.png?v=13426386756341579816" alt="Slider Arrow"></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><img src="//joyorganics.com/cdn/shop/files/lpg-sliderArrow2.png?v=13426386756341579816" alt="Slider Arrow"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2, 
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    var youtubePlayers = [];

    let videoThumbnail;
    let videoThumbnailNav;
    let videoThumbnailThumb;

    $('.eq-video-thumbnail').each(function() {
        videoThumbnail = $(this);

        videoThumbnailNav = videoThumbnail.find('.js-video-thumbnail-nav .eq-video-thumbnail__slide');
        videoThumbnailThumb = videoThumbnail.find('.js-video-thumbnail-thumb .eq-video-thumbnail__slide');
    
        if (videoThumbnailNav.length > 0 && videoThumbnailThumb.length > 0 && videoThumbnailNav.length === videoThumbnailThumb.length) {
            // Initialize main slider (js-video-thumbnail-nav) for this specific container
            videoThumbnail.find('.js-video-thumbnail-nav').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                fade: true,
                asNavFor: videoThumbnail.find('.js-video-thumbnail-thumb'),
                dots: false,
                swipe: true,
                touchThreshold: 10,
                draggable: true,
                swipeToSlide: true,
            });

            // Initialize thumbnail slider (js-video-thumbnail-thumb) for this specific container
            videoThumbnail.find('.js-video-thumbnail-thumb').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                asNavFor: videoThumbnail.find('.js-video-thumbnail-nav'),
                dots: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path></svg></button>',
                nextArrow: '<button type="button" class="next-arrow" aria-label="next"><svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path></svg></button>',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        } else {
            
        }
    });

    $('.js-video-thumbnail-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
        pauseVideo(currentSlide);
    });

    function pauseVideo(slideIndex) {
        var iframe = $('.js-video-thumbnail-nav').find('.eq-video-thumbnail__slide').eq(slideIndex).find('iframe');
        var player;

        if (iframe.length > 0) {
            var videoId = iframe.attr('src').split('/')[4].split('?')[0];
            if (!youtubePlayers[videoId]) {
                youtubePlayers[videoId] = new YT.Player(iframe[0], {
                    events: {
                        'onReady': function(event) {
                            player = event.target;
                        }
                    }
                });
            } else {
                player = youtubePlayers[videoId];
            }

            if (player && player.pauseVideo) {
                player.pauseVideo();
                player.stopVideo();
            }
        }
    }
    

    if ($('.eq-accordion-sales__question').length > 0) {
      
        $(".eq-accordion-sales__col:first-child .eq-accordion-sales__block").addClass('is-active-accordion');
        $(".eq-accordion-sales__col:first-child .eq-accordion-sales__answer").addClass('is-open-detail').show();


        $('.eq-accordion-sales__box').each(function(index) {
            let currentBox = $(this);

            currentBox.find('.eq-accordion-sales__question').on('click', function() {
                let accordionBlock = $(this).closest('.eq-accordion-sales__block');
                let accordionAnswer = accordionBlock.find('.eq-accordion-sales__answer');

                $('.eq-accordion-sales__block').not(accordionBlock).removeClass('is-active-accordion');
                $('.eq-accordion-sales__answer').not(accordionAnswer).removeClass('is-open-detail').slideUp(350);

                if (!accordionBlock.hasClass('is-active-accordion')) {
                    accordionBlock.addClass('is-active-accordion');
                    accordionAnswer.addClass('is-open-detail').slideDown(350);
                } else {
                    accordionBlock.removeClass('is-active-accordion');
                    accordionAnswer.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }


    let tooltipInfo = $(".an_learn_more-popup");

    $(document).on('click','.js-more-info-toolTip',function() {
      if(tooltipInfo.length > 0 && !tooltipInfo.hasClass('eq-popup-open')){
        tooltipInfo.addClass("eq-popup-open");
      }
    });

    $(document).on('click', ".js-popup-close-btn" ,function() {
      if(tooltipInfo.length > 0 && tooltipInfo.hasClass("eq-popup-open")){
        tooltipInfo.removeClass("eq-popup-open");
      }
    });
    
    let moreTagButton = $('.js-more-tag-button');
    if(moreTagButton.length > 0 && window.outerWidth < 768) {
        moreTagButton.on('click', function(event){
            let currentBtn = event.target;
            let listTag = $(currentBtn).parents('.joy-tags').find('.joy-tags__list li');
            $(listTag).each(function(index , element){
                if((listTag.length > 7 && index > 7)){
                    if (index !== listTag.length - 1) {
                        if($(element).hasClass('is-tag-visible')){
                            $(element).removeClass('is-tag-visible');
                            moreTagButton.text('less');
                        } else {
                            $(element).addClass('is-tag-visible');
                          moreTagButton.text('more');
                        }
                    }
                }
            });

        });
    }

    $('.joy-author__icon').on('click', function(event) {
        event.stopPropagation();
        $('.joy-author__tooltip').toggleClass('is-active-tooltip');
    });
    
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.joy-author__icon, .joy-author__tooltip').length) {
          $('.joy-author__tooltip').removeClass('is-active-tooltip');
        }
    });
let topSellingProduct = $('.js-top-seller');

    if(topSellingProduct.length > 0 && topSellingProduct.not(".slick-initialized") && topSellingProduct.find('.eq-top-seller__slide').length > 0 ){
        topSellingProduct.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            variableWidth: false,
            loop: false,
            infinite: false,
            autoplay: false,
            prevArrow: '<button type="button" class="prev-arrow" aria-label="previous"><svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4141 3.41406L5.82812 10L12.4141 16.5859L9.58594 19.4141L0.171875 10L9.58594 0.585938L12.4141 3.41406Z" fill="#A12655"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow" aria-label="next"><svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.585938 3.41406L7.17188 10L0.585938 16.5859L3.41406 19.4141L12.8281 10L3.41406 0.585938L0.585938 3.41406Z" fill="#A12655"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let descriptionCollapseEButton = $('.js-collapse-expand-button .eq-button');
    
    descriptionCollapseEButton.each(function(index , currentButton) {

        if($(currentButton).length > 0) {
            $(currentButton).on("click", function() {
                let currentDetailBox = $(this).parent().prev();

                if(currentDetailBox.length > 0){
                    let shortDescription = $(currentDetailBox).find('.js-short-description');
                    let longDescription = $(currentDetailBox).find('.js-long-description');

                    if(shortDescription && longDescription && !currentDetailBox.hasClass("is-visible-more-detail")) {
                        currentDetailBox.addClass("is-visible-more-detail");
                        $(currentButton).find(".eq-button__text").text('read less');
                    } else {
                        currentDetailBox.removeClass("is-visible-more-detail");
                        $(currentButton).find(".eq-button__text").text('read more');
                    }
                }                
            });
        }
    });

    let snowfallContainer = document.querySelector(".eq-banner__snowflake");

    if(snowfallContainer) {
        // Increase snowflake count
        let numberOfSnowflakes = Math.floor(Math.random() * 40) + 150;
    
        for (let i = 0; i < numberOfSnowflakes; i++) {
            // mix flakes & balls randomly
            Math.random() > 0.5 ? createSnowflake() : createSnowball();
        }
    
        function createSnowflake() {
            let snowflake = document.createElement("div");
            snowflake.classList.add("snowflake");
            setRandomProperties(snowflake);
            snowfallContainer.appendChild(snowflake);
        }
    
        function createSnowball() {
            let snowball = document.createElement("div");
            snowball.classList.add("snowball");
            setRandomProperties(snowball, true);
            snowfallContainer.appendChild(snowball);
        }
    
        function setRandomProperties(element, isBall = false) {
            // random horizontal position
            let randomLeft = Math.random() * 100;
            element.style.left = `${randomLeft}%`;
    
            // 📏 size distribution: 60% small, 30% medium, 10% large
            let rand = Math.random();
            let size;
            if (rand < 0.6) {
                // small (more common)
                size = isBall ? Math.random() * 3 + 2 : Math.random() * 5 + 3;
            } else if (rand < 0.8) {
                // medium
                size = isBall ? Math.random() * 6 + 4 : Math.random() * 8 + 7;
            } else {
                // large (rare)
                size = isBall ? Math.random() * 10 + 6 : Math.random() * 12 + 22;
            }
    
            element.style.width = `${size}px`;
            element.style.height = `${size}px`;
    
            // 🎯 random vertical start position (anywhere from -10% to 100% of viewport)
            let startTop = Math.random() * window.innerHeight - window.innerHeight * 0.5;
            element.style.top = `${startTop}px`;
    
            let randomRotation = Math.random() * 360;
            element.style.transform = `rotate(${randomRotation}deg)`;
    
            // 🕒 Control fall speed — slower animation
            let randomDuration = Math.random() * 8 + 6; // 8–16 seconds
            let randomDelay = Math.random() * 5;
            element.style.animation = `snowfall ${randomDuration}s ${randomDelay}s linear infinite`;
    
            let randomTransitionSecond = Math.random() * 1000 + 300;
            element.style.transition = `opacity ${randomTransitionSecond}ms ease-in-out ${randomDelay}s`;
    
            setTimeout(() => {
                element.style.opacity = Math.random() * 0.6 + 0.4;
            }, randomDelay * 1000);
        }
    }

     let joyBannerSlider = $('.js-joy-banner-slider');

    joyBannerSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        pauseOnFocus: true
    });

    // Stop autoplay when user interacts (like your original logic)
    $('.js-joy-banner-slider').on('click', '.slick-arrow, .slick-dots button', function () {
        joyBannerSlider.slick('slickPause');
    });

    let redeemVideoLink = $('.js-redeem-video-link');
    let redeemVideoPopup = $('.redeem-video-popup');

    if (typeof $.fancybox !== "undefined") {
        if (
            redeemVideoLink.length > 0 &&
            redeemVideoPopup.length > 0
        ) {
            
            $('.js-redeem-video-link[data-fancybox="redeem-video"]').fancybox({
                animationEffect: 'fade', 
                animationDuration: 300,

                autoplay: false,
                touch: false,
                arrows: false,
                smallBtn: false,

                clickSlide: false,
                clickOutside: true,

                closeClick: true,

                baseClass: 'custom-popup-style redeem-video-popup-show',

                beforeShow: function(instance, current) {
                    let video = $(current.src).find('video').get(0);
                    if (video) {
                        video.autoplay = false;
                        video.pause();
                    }
                },

                afterShow: function(instance, current) {
                    let video = current.$content.find('video').get(0);
                    
                    if (video) {
                        video.autoplay = false;
                        video.pause();
                    }

                    setTimeout(() => {
                        if (video) {
                            video.autoplay = false;
                            video.pause();
                        }   
                    }, 50);
                }
            }); 
        }
    }
    
});

 
function handleStickyElements() {
    let eqAnnouncementBar = $('.eq-announcement-bar');
    let eqHeader = $('.eq-header');
   
    if ($(eqAnnouncementBar).hasClass('eq-sticky-announcement-bar') && $(eqHeader).hasClass('eq-sticky-header')) {
        let announcementBarHeight = eqAnnouncementBar.outerHeight();
        if(eqHeader.parent().hasClass('shopify-section')){
            eqHeader.parent().css({
                'top': `${announcementBarHeight}px`,
            });
        }
    } else {
        if(eqHeader.parent().hasClass('shopify-section')){
            eqHeader.parent().css({
                'top': '0px',
            });
        }
    }
}

let stickyResizeTimer;
function debouncedResizeHandlers() {
    clearTimeout(stickyResizeTimer);
    stickyResizeTimer = setTimeout(function () {
        handleStickyElements();
        setAnnauncementAndHeaderHeights();
        setDocWidth();
    }, 150);
}

$(window).resize(debouncedResizeHandlers);
window.addEventListener('resize', debouncedResizeHandlers);

$(window).on('load', function() {
    handleStickyElements();
     let topSellingProductCategory = $('.eq-top-seller__slide .card-wrapper .selling-product__category');

    if(topSellingProductCategory.length > 0){
        topSellingProductCategory.matchHeight({ 
            byRow: true,
        });
    }

    let topSellingProductName = $('.eq-top-seller__slide .card-wrapper .card__content .card__information .card__heading');

    if(topSellingProductName.length > 0){
        topSellingProductName.matchHeight({ 
            byRow: true,
        });
    }

    let topSellingProductBadge = $('.eq-top-seller__slide .card-wrapper .card__content .card__information .eq-collection-benefits-badge');

    if(topSellingProductBadge.length > 0){
        topSellingProductBadge.matchHeight({ 
            byRow: true,
        });
    }
    
    let topSellingProductStrength = $('.eq-top-seller__slide .card-wrapper .card__content .card__information .eq-product-strength');

    if(topSellingProductStrength.length > 0){
        topSellingProductStrength.matchHeight({ 
            byRow: true,
        });
    }

    let topSellingProductPrice = $('.eq-top-seller__slide .card-wrapper .card__content .card__information .eq-product-price');

    if(topSellingProductPrice.length > 0){
        topSellingProductPrice.matchHeight({ 
            byRow: true,
        });
    }
});

/*if ($('.js-cbd-best-sellers-slider').length > 0) {
    $('.js-cbd-best-sellers-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,        
        loop: false,
        infinite: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}*/


// 08-09-2026
$(document).ready(function(){
    if ($('.js-find-your-solution-slider').length > 0) {
    $('.js-find-your-solution-slider').each(function () {
        const $findSolutionSlider = $(this);
 
        // ADA: must be attached BEFORE .slick() so the 'init' event is caught
        if (window.slickA11y) slickA11y.attach($findSolutionSlider);
 
        $findSolutionSlider.slick({
            accessibility: false, // ADA: Slick's built-in mode creates the "1 of 2 tab" issue
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.7,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1.06,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}
    if($(".eq-find-your-solution__box-content p").length > 0){
        $(".eq-find-your-solution__box-content p").matchHeight({ 
            byRow: true,
        });
    }

    const customerSayingSlider = document.querySelectorAll('.js-customers-saying-slider');

    if ($('.js-customers-saying-slider').length > 0) {

        const matchCardHeight = function () {
            console.log('customerSayingSlider matchCardHeight');

            $(customerSayingSlider).find('.review-short-desc').matchHeight({
                byRow: false
            });

            $(customerSayingSlider).find('.auth-details').matchHeight({
                byRow: false
            });
        };

        matchCardHeight();

        
        $('.js-customers-saying-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            autoplay: true,
            prevArrow: $('.js-customers-saying-prev'),
            nextArrow: $('.js-customers-saying-next'),
            touchThreshold: 10,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        autoplay: false,
                        infinite: false
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        autoplay: false,
                        infinite: false
                    }
                }
            ]
        });

        $(customerSayingSlider).on('setPosition', function () {
            console.log('customerSayingSlider slide setPosition matchCardHeight');
            
            setTimeout(() => {
                matchCardHeight();
            }, 100);
        });
    }
});

// 08-09-2026

function ageCookie () {
     const cookies = document.cookie.split(';').map(c => c.trim());
     const ageCookie = cookies.find(c => c.startsWith('agegate_response='));
 
     if (ageCookie) {
         const value = ageCookie.split('=')[1];
         document.cookie = `agegate_responses=${value}; path=/`; 
     }
 }
 
 ageCookie();
 
 if (window.location.pathname.indexOf('/products') > -1) {
     let lastCookie = document.cookie;
     const interval = setInterval(() => {
         if (document.cookie !== lastCookie) {
             lastCookie = document.cookie;
             if (document.cookie.includes('agegate_response=')) {
                 ageCookie();
             }
         }
     }, 200); 
 }
 
 
 $('body').on('click',"[name=checkout]", function (e) {
   e.preventDefault(); 
   var cookies = document.cookie.split(';').map(cookie => cookie.trim());
   var ageGateCookie = cookies.find(cookie => cookie.startsWith('agegate_responses='));
   if (ageGateCookie) {
     const value = ageGateCookie.split('=')[1];
     const parts = value.split('Clicked:');
     const ageStatus = parts[0]?.trim() || '';
     const clickedAt = parts[1]?.trim() || '';
   
   
     fetch('/cart/update.js', {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({
         attributes: {
           age_status: ageStatus,
           age_verified_at: clickedAt
         }
       })
     })
     .then(res => res.json())
     .then(data => {
       window.location.href = '/checkout';
     })
     .catch(err => {
       console.error('Cart update failed:', err);
     });
 
   }
 
   window.location.href = '/checkout';
 });

 function setAnnauncementAndHeaderHeights() {
    const announcementBar = document.querySelector('.js-eq-announcement-bar-v2');
    const mainMenu = document.querySelector('.eq-header__main-menu');

    const announcementBarHeight = announcementBar?.offsetHeight || 0;
    const mainMenuHeight = mainMenu?.offsetHeight || 0;

    document.body.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
    document.body.style.setProperty('--top-header-height', `${mainMenuHeight}px`);
}

function setDocWidth() {
  document.body.style.setProperty('--body-width', `${document.documentElement.clientWidth}px`);
}

document.addEventListener('DOMContentLoaded', function() {
    setAnnauncementAndHeaderHeights();
    setDocWidth();
});

document.addEventListener('DOMContentLoaded', function () {

    let trustedVoicesPreviousVideo = null;

    /**
     * Update video control state
     *
     * States:
     * - playing
     * - paused
     * - ended
     */
    function updateVideoControls(videoBlock, state) {
        if (!videoBlock) return;

        videoBlock.classList.remove(
            'is-playing',
            'is-paused',
            'is-ended'
        );

        videoBlock.classList.add('is-' + state);
    }


    /**
     * Play video
     */
    function playTrustedVoicesVideo(video) {
        if (!video) return;

        // If video has ended, start again from beginning
        if (video.ended) {
            video.currentTime = 0;
        }

        video.play().catch(function (error) {
            console.log('Video play failed:', error);
        });
    }


    /**
     * Pause video
     */
    function pauseTrustedVoicesVideo(video) {
        if (!video) return;

        video.pause();

        const videoBlock = video.closest('.video-carousel__block');

        updateVideoControls(videoBlock, 'paused');

        // Clear previous video reference
        if (trustedVoicesPreviousVideo === video) {
            trustedVoicesPreviousVideo = null;
        }
    }


    /**
     * Reset video
     */
    function resetTrustedVoicesVideo(video) {
        if (!video) return;

        video.pause();
        video.currentTime = 0;

        const videoBlock = video.closest('.video-carousel__block');

        updateVideoControls(videoBlock, 'paused');

        // Clear previous video reference
        if (trustedVoicesPreviousVideo === video) {
            trustedVoicesPreviousVideo = null;
        }
    }


    /**
     * Video ended
     */
    function handleTrustedVoicesVideoEnded(video) {
        if (!video) return;

        const videoBlock = video.closest('.video-carousel__block');

        updateVideoControls(videoBlock, 'ended');

        // Clear previous video reference
        if (trustedVoicesPreviousVideo === video) {
            trustedVoicesPreviousVideo = null;
        }
    }


    /**
     * Bind video controls/events
     */
    function bindTrustedVoicesVideoControls(video) {
        if (!video) return;

        const $video = $(video);
        const videoBlock = video.closest('.video-carousel__block');

        if (!videoBlock) return;

        const $videoBlock = $(videoBlock);

        const $playButton = $videoBlock.find(
            '.js-video-carousel-play-button'
        );

        const $pauseButton = $videoBlock.find(
            '.js-video-carousel-pause-button'
        );


        /*
        * Play button
        */
        $playButton
            .off('click.trustedVoicesVideo')
            .on('click.trustedVoicesVideo', function (e) {
                e.preventDefault();
                e.stopPropagation();

                playTrustedVoicesVideo(video);
            });


        /*
        * Pause button
        */
        $pauseButton
            .off('click.trustedVoicesVideo')
            .on('click.trustedVoicesVideo', function (e) {
                e.preventDefault();
                e.stopPropagation();

                pauseTrustedVoicesVideo(video);
            });


        /*
        * Video events
        */
        $video
            .off('.trustedVoicesVideo')


            /*
            * VIDEO PLAY
            *
            * Whenever a video starts playing,
            * stop the previously playing video.
            */
            .on('play.trustedVoicesVideo', function () {
                const currentVideo = this;


                /*
                * If another video is already playing,
                * pause only that video.
                *
                * No each() loop required.
                */
                if (
                    trustedVoicesPreviousVideo &&
                    trustedVoicesPreviousVideo !== currentVideo
                ) {
                    trustedVoicesPreviousVideo.pause();
                    trustedVoicesPreviousVideo.currentTime = 0;


                    const previousVideoBlock =
                        trustedVoicesPreviousVideo.closest(
                            '.video-carousel__block'
                        );


                    updateVideoControls(
                        previousVideoBlock,
                        'paused'
                    );
                }


                /*
                * Store currently playing video
                */
                trustedVoicesPreviousVideo = currentVideo;


                /*
                * Update current video controls
                */
                updateVideoControls(
                    currentVideo.closest('.video-carousel__block'),
                    'playing'
                );
            })


            /*
            * VIDEO PAUSE
            */
            .on('pause.trustedVoicesVideo', function () {
                const currentVideo = this;

                /*
                * Don't change it to paused when
                * video has naturally ended.
                */
                if (!currentVideo.ended) {
                    updateVideoControls(
                        currentVideo.closest('.video-carousel__block'),
                        'paused'
                    );
                }
            })


            /*
            * VIDEO ENDED
            */
            .on('ended.trustedVoicesVideo', function () {
                handleTrustedVoicesVideoEnded(this);
            });
    }


    /**
     * Initialize all videos inside slider
     */
    function initTrustedVoicesVideos(slider) {
        slider.find('video').each(function () {
            const video = this;

            /*
            * Initial state
            */
            updateVideoControls(
                video.closest('.video-carousel__block'),
                'paused'
            );


            /*
            * Bind controls
            */
            bindTrustedVoicesVideoControls(video);


            /*
            * Optional external API
            *
            * Allows:
            *
            * video.trustedVoicesVideo.play();
            * video.trustedVoicesVideo.pause();
            * video.trustedVoicesVideo.reset();
            */
            video.trustedVoicesVideo = {
                play: function () {
                    playTrustedVoicesVideo(video);
                },

                pause: function () {
                    pauseTrustedVoicesVideo(video);
                },

                reset: function () {
                    resetTrustedVoicesVideo(video);
                }
            };
        });
    }


    const slider = document.querySelector('.js-featured-in-slider');

    console.log("actualSlideCount slider : ", slider);

    if (slider) {
        const actualSlideCount = parseInt(slider.dataset.slideCount, 10);

        console.log("actualSlideCount : ", actualSlideCount);
    
        function updateFeaturedSlider() {
            const isMobile = window.innerWidth <= 991;
    
            // Desktop: marquee when more than 5 slides
            // <=991px: marquee when more than 3 slides

            const requiredSlideCount = isMobile ? 3 : 5;
    
            slider.classList.toggle(
                'is-marquee-active',
                actualSlideCount > requiredSlideCount
            );
        }
    
        updateFeaturedSlider();
    
        window.addEventListener('resize', updateFeaturedSlider);
    }


    // const shopByCategorySlider = document.querySelectorAll('.js-shop-by-category-slider');

    // if (shopByCategorySlider.length > 0) {
    //     $(shopByCategorySlider).each(function () {
    //         let currentShopByCategorySlider = $(this);

    //         const matchCardHeight = function () {

    //             console.log('matchCardHeight');

    //             currentShopByCategorySlider.find('.shop-by-category__card-title').matchHeight({
    //                 byRow: false
    //             });

    //             currentShopByCategorySlider.find('.shop-by-category__card-info').matchHeight({
    //                 byRow: false
    //             });
    //         };

    //         console.log('before matchCardHeight');
    //         matchCardHeight();

    //         currentShopByCategorySlider.slick({
    //             slidesToShow: 5,
    //             slidesToScroll: 1,
    //             infinite: false,
    //             arrows: false,
    //             dots: true,
    //             speed: 500,
    //             touchThreshold: 10,
    //             responsive: [
    //                 {
    //                     breakpoint: 1800,
    //                     settings: {
    //                         slidesToShow: 4,
    //                     }
    //                 },
    //                 {
    //                     breakpoint: 1400,
    //                     settings: {
    //                         slidesToShow: 3,
    //                     }
    //                 },
    //                 {
    //                     breakpoint: 641,
    //                     settings: {
    //                         slidesToShow: 1.5,
    //                     }
    //                 }
    //             ]
    //         });

    //         currentShopByCategorySlider.on('setPosition', function () {
    //             console.log('slide setPosition matchCardHeight');
                
    //             setTimeout(() => {
    //                 matchCardHeight();
    //             }, 100);
    //         });
    //     });
    // }
 /* Shop By Category */
const shopByCategorySlider = document.querySelectorAll('.js-shop-by-category-slider');
 
if (shopByCategorySlider.length > 0) {
    $(shopByCategorySlider).each(function () {
        let currentShopByCategorySlider = $(this);
 
        const matchCardHeight = function () {
            currentShopByCategorySlider.find('.shop-by-category__card-title').matchHeight({
                byRow: false
            });
 
            currentShopByCategorySlider.find('.shop-by-category__card-info').matchHeight({
                byRow: false
            });
        };
 
        matchCardHeight();
 
        // ADA: must be attached BEFORE .slick() so the 'init' event is caught
        if (window.slickA11y) slickA11y.attach(currentShopByCategorySlider);
 
        currentShopByCategorySlider.slick({
            accessibility: false, // ADA: Slick's built-in mode creates the "1 of 2 tab" issue
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: true,
            speed: 500,
            touchThreshold: 10,
            responsive: [
                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1.5,
                    }
                }
            ]
        });
 
        // NOTE: removed `.find('.slick-slide').removeAttr('role')` from here –
        // it fired on every resize and wiped the slide role the ADA fix sets.
        currentShopByCategorySlider.on('setPosition', function () {
            setTimeout(() => {
                matchCardHeight();
            }, 100);
        });
    });
}

    const customerFavoritesSlider = document.querySelectorAll('.js-customer-favorites-slider');

    if (customerFavoritesSlider.length > 0) {       
        $(customerFavoritesSlider).each(function () {
            let currentCustomerFavoritesSlider = $(this);

            const matchCardHeight = function () {

                console.log('customer-favorites matchCardHeight');

                currentCustomerFavoritesSlider.find('.customer-favorites__card-title').matchHeight({
                    byRow: false
                });

                currentCustomerFavoritesSlider.find('.customer-favorites__card-label').matchHeight({
                    byRow: false
                });
            };

            console.log('before customer-favorites matchCardHeight');
            matchCardHeight();

            console.log('customer-favorites prev ', currentCustomerFavoritesSlider.parents('.customer-favorites__wrapper').find('.js-customer-favorites-arrow-prev'));

            currentCustomerFavoritesSlider.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                speed: 500,
                touchThreshold: 10,
                prevArrow: currentCustomerFavoritesSlider
                    .parents('.customer-favorites__wrapper')
                    .find('.js-customer-favorites-arrow-prev'),
                nextArrow: currentCustomerFavoritesSlider
                    .parents('.customer-favorites__wrapper')
                    .find('.js-customer-favorites-arrow-next'),
                responsive: [
                    {
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            currentCustomerFavoritesSlider.on('setPosition', function () {
                console.log('slide setPosition matchCardHeight');
                setTimeout(() => {
                    matchCardHeight();
                }, 100);
            });

        });
    }


    const trustedVoicesSlider = document.querySelectorAll('.js-video-carousel');

    if (trustedVoicesSlider.length > 0) {
        $(trustedVoicesSlider).each(function () {
            let currentTrustedVoicesSlider = $(this);

            /*
            * Get arrows
            */
            const prevArrow = currentTrustedVoicesSlider
                .parent()
                .find('.js-trusted-voices-arrow-prev')[0];

            const nextArrow = currentTrustedVoicesSlider
                .parent()
                .find('.js-trusted-voices-arrow-next')[0];

            currentTrustedVoicesSlider.slick({
                initialSlide: 1,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                speed: 500,
                touchThreshold: 10,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

             let slickSlider = $('.js-video-carousel'); // Select your slick slider by its class or ID
            let slickSliderInner = $('.js-video-carousel .slick-track');

            // // Ensure the slider is initialized before accessing slide count
            // let slideCount = slickSlider.slick('getSlick').slideCount;
            // console.log('slideCount', slideCount);
            
            // // Add or remove class based on slide count
            // if (slideCount <= 4) {
            //     // console.log('if');
            //     slickSliderInner.addClass('no-transform'); // Add the class to the slider container
            // } else {
            //     // console.log('else');
            //     slickSliderInner.removeClass('no-transform'); // Remove the class from the slider container
            // }
            function updateNoTransform() {
                if (!slickSlider.hasClass('slick-initialized')) return;

                let slick = slickSlider.slick('getSlick');
                let slideCount = slick.slideCount;

                // Mobile: remove no-transform class so Slick can slide normally
                if (window.matchMedia('(max-width: 767px)').matches) {
                    slickSliderInner.removeClass('no-transform');
                } else {
                    // Desktop: add class when there are 4 or fewer slides
                    if (slideCount <= 4) {
                        slickSliderInner.addClass('no-transform');
                    } else {
                        slickSliderInner.removeClass('no-transform');
                    }
                }
            }

            // Run after Slick initialization
            updateNoTransform();

            // Update class when screen size changes
            $(window).on('resize', function () {
                updateNoTransform();
            });

            /*
            * Initialize video functionality
            */
            initTrustedVoicesVideos(currentTrustedVoicesSlider);

            /*
            * Slick slide change
            *
            * Stop/reset the currently playing video
            * when user changes slide.
            */
            currentTrustedVoicesSlider.on('beforeChange.trustedVoicesVideo', function (event, slick, currentSlide, nextSlide) {
                /*
                * Only reset the video that is currently
                * stored as playing.
                */
                if (trustedVoicesPreviousVideo) {
                    resetTrustedVoicesVideo(trustedVoicesPreviousVideo);
                }
            });

        });
    }


    // Product Page JS start

    // Select all video blocks on the page
    const videoBlocks = document.querySelectorAll('.js-product-video-block');

    if(videoBlocks.length) {
        console.log("videoBlocks : ", videoBlocks);

        videoBlocks.forEach(block => {
            const video = block.querySelector('video');
            const playBtn = block.querySelector('.js-product-video-play-button');
            const pauseBtn = block.querySelector('.js-product-video-pause-button');

            if (!video || !playBtn || !pauseBtn) return;

            // Helper function to update visibility/state based on playing status
            const updateVideoState = (isPlaying) => {
                if (isPlaying) {
                    block.classList.add('active-pause-control');
                } else {
                    block.classList.remove('active-pause-control');
                }
            };

            // Play Button Click
            playBtn.addEventListener('click', () => {
                console.log("playBtn : ");

                video.play().then(() => {
                    console.log("playBtn updateVideoState : ");
                    updateVideoState(true);
                }).catch(error => {
                    console.error("Playback failed:", error);
                });
            });

            // Pause Button Click
            pauseBtn.addEventListener('click', () => {
                console.log("pauseBtn : ");

                video.pause();
                console.log("pauseBtn updateVideoState : ");
                updateVideoState(false);
            });

            // Handle Video Ended Event
            video.addEventListener('ended', () => {
                console.log("video : ");

                updateVideoState(false);
                // Optional: reset video time to beginning if desired
                // video.currentTime = 0; 
            });

            // Sync state if video is controlled natively or via other means
            video.addEventListener('play', () => updateVideoState(true));
            video.addEventListener('pause', () => updateVideoState(false));
        });
    } else {
        console.log("Not Found Video Block ");
        
    }

    const comparisonWrappers = document.querySelectorAll('.js-compare-products-wrap');

    console.log("comparisonWrappers ");

    if(comparisonWrappers.length) {
        console.log("comparisonWrappers IF");
        
        comparisonWrappers.forEach((wrapper) => {
            // 1. Match height for static structural elements
            const mediaElements = wrapper.querySelectorAll('.js-compare-media');
            const headingElements = wrapper.querySelectorAll('.js-compare-heading');
            const ctaElements = wrapper.querySelectorAll('.js-compare-cta');

            if (mediaElements.length) $(mediaElements).matchHeight({ byRow: false });
            if (headingElements.length) $(headingElements).matchHeight({ byRow: false });
            if (ctaElements.length) $(ctaElements).matchHeight({ byRow: false });

            // 2. Single-pass dynamic point matching using a lookup map
            const pointElements = wrapper.querySelectorAll('[data-points-index]');
            if (pointElements.length) {
                const pointsByIndex = {};
    
                // Group elements by their index in a single O(N) iteration
                pointElements.forEach((element) => {
                    const index = element.getAttribute('data-points-index');
                    if (!pointsByIndex[index]) {
                        pointsByIndex[index] = [];
                    }
                    pointsByIndex[index].push(element);
                });
    
                // Apply matchHeight to each grouped collection
                Object.values(pointsByIndex).forEach((group) => {
                    if (group.length) {
                        $(group).matchHeight({ byRow: false });
                    }
                });
            }

        });
    } else {
        console.log("comparisonWrappers ELSE");
    }

    // Pure JavaScript Slide Animations
    function slideUp(element, duration = 300, callback = null) {
      element.style.height = element.offsetHeight + 'px';
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.offsetHeight; // Force repaint
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;

      window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
        if (callback) callback();
      }, duration);
    }

    function slideDown(element, duration = 300) {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      element.style.display = display;

      let height = element.offsetHeight;
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.offsetHeight; // Force repaint
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.style.height = height + 'px';

      window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
      }, duration);
    }

    const accordionWrappers = document.querySelectorAll('.js-accordion-wrapper');

    accordionWrappers.forEach((wrapper) => {
      wrapper.addEventListener('click', function (e) {
        const questionBtn = e.target.closest('.js-accordion-question');
        if (!questionBtn) return;

        const currentBlock = questionBtn.closest('.accordion__block');
        const currentAnswer = currentBlock.querySelector('.js-accordion-answer');
        const isExpanded = currentBlock.classList.contains('is-accordion-visible');

        if (isExpanded) {
          // Slide Up / Close
          questionBtn.setAttribute('aria-expanded', 'false');
          slideUp(currentAnswer, 300, () => {
            currentBlock.classList.remove('is-accordion-visible');
          });
        } else {
          // Slide Down / Open
          currentBlock.classList.add('is-accordion-visible');
          questionBtn.setAttribute('aria-expanded', 'true');
          slideDown(currentAnswer, 300);
        }
      });
    });

    const productSections = document.querySelectorAll('.product-detail-v2');
    const stickyBtn = document.querySelector('.sticky-atc-bar');
    const footer = document.querySelector('footer'); // Update this selector if your footer has a specific class/id (e.g., '.site-footer')

    let lastScrollTop = window.scrollY || document.documentElement.scrollTop;

    function isElementPartiallyInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function isAnyProductVisible() {
        return Array.from(productSections).some(isElementPartiallyInViewport);
    }

    // Dynamically apply sticky bar height as bottom spacing to the footer
    function updateFooterSpacing() {
        if (stickyBtn && footer) {
            // Get the actual height of the sticky button
            const stickyHeight = stickyBtn.offsetHeight;
            // Add it as padding-bottom to the footer
            footer.style.paddingBottom = `${stickyHeight + 20}px`; // Extra 20px for breathing room
        }
    }
    
    function updateStickyButton() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollingDown = scrollTop > lastScrollTop;
        const productVisible = isAnyProductVisible();
        
        if (scrollingDown && !productVisible) {
            stickyBtn.classList.add('visible');
        } else if (!scrollingDown && productVisible) {
            stickyBtn.classList.remove('visible');
        } else if (!scrollingDown && !productVisible) {
            stickyBtn.classList.add('visible');
        } else if (productVisible) {
            stickyBtn.classList.remove('visible');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    window.addEventListener('scroll', () => {
        updateStickyButton();
        updateFooterSpacing();
    });

    window.addEventListener('load', () => {
        updateStickyButton();
        updateFooterSpacing();
    });

    window.addEventListener('resize', updateFooterSpacing); // Recalculate if screen size changes

    // Product Page JS end

});

document.querySelectorAll('.eq-header__nav-link[aria-haspopup]').forEach(function (link) {
  var item = link.closest('.eq-header__nav-item');
  function set(open) { link.setAttribute('aria-expanded', open); }

  item.addEventListener('mouseenter', function () { set(true); });
  item.addEventListener('mouseleave', function () { set(false); });
  item.addEventListener('focusin', function () { set(true); });
  item.addEventListener('focusout', function (e) {
    if (!item.contains(e.relatedTarget)) set(false);
  });
});